import React from "react";
import { Reveal } from "./Reveal";
import { SPECS } from "../data/copy";

const Dots = () => (
  <span className="mk-divider-dots" aria-hidden="true">
    <i />
    <i />
  </span>
);

/**
 * Section 7 — Specs. Graphite background, mint dots, three columns.
 */
export const Specs = () => {
  return (
    <section id="specs" className="mk-specs" data-testid="specs-section">
      <Reveal className="mk-specs__inner">
        <Dots />
        <h2 className="mk-specs__heading">{SPECS.heading}</h2>
        <div className="mk-specs__grid">
          {SPECS.items.map((item, i) => (
            <Reveal
              key={item.label}
              delay={i * 120}
              className="mk-spec"
              data-testid={`spec-${item.label}`}
            >
              <span className="mk-spec__value">{item.value}</span>
              <span className="mk-spec__label">{item.label}</span>
            </Reveal>
          ))}
        </div>
      </Reveal>
    </section>
  );
};

export default Specs;
